import { render } from "./customDialog.vue?vue&type=template&id=78770242&lang=true"
import script from "./customDialog.vue?vue&type=script&lang=js"
export * from "./customDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__